
(function () {
    'use strict';

    angular.module('itxApp.catalog').service('SeoService', ItxCategorySvc);

    ItxCategorySvc.$inject = [
        'categoryTreeSvc',
        'attachmentManagerSvc'
    ];
 
    function ItxCategorySvc(
        categoryTreeSvc,
        attachmentManagerSvc
    ){

        var _this = this;

        function _reloadContext(url, callback) {

  
            if(url.indexOf('celement')>-1){
            
                url = url + '&itxSeo=true';
            }
            else{
                url = url.split('?')[0];
                url = url + '?itxSeo=true';
            }


            joyr.rest.xRestExecute([{
                'action': url
            }]).done(function(data) {



                var value = data[0];
                if (value != null) {
                    inditex.seoInfo = value;
                    if (inditex.seoInfo) {
                        $('title').html(inditex.seoInfo.title);
                        $('meta[name=\'title\']').attr('content', inditex.seoInfo.metaDescription);
                        $('meta[name=\'description\']').attr('content', inditex.seoInfo.metaDescription);
                    }
                }
                if (callback && typeof callback === 'function') {
                    callback(true);
                }
            }).Catch(function(value) {
                callback(false, value);
            });



        }

        function setCategoryTitle(){
            categoryTreeSvc.getFamilyCurrentCategory().then(function (res) { 
              if(res.category) {
                var categoryAttachment = attachmentManagerSvc.checkAttachmentConfig(res.category);
                if(categoryAttachment.renamed && categoryAttachment.name !== null) {
                  $('title').html(categoryAttachment.name);
                  $('.copy-title').html(categoryAttachment.name);
                } else {
                  $('title').html(inditex.seoInfo.title);
                }
              }
            });
        }

        function updateMetas() {
            _reloadContext(document.location.href, function (status) {
                if (inditex.iPage === '/ItxProductPage') {
                    inditex.iPage = 'ItxProductPage';
                }
                var mainHeader = '',
                    longDescription = '',
                    productH1 = '';
                if (status) {
                    $('meta[property="og:title"]').attr('content', inditex.seoInfo.title);
                    $('meta[property="twitter:title"]').attr('content', inditex.seoInfo.title);

                    // update description
                    $('meta[property="og:description"]').attr('content', inditex.seoInfo.metaDescription);
                    $('meta[property="twitter:description"]').attr('content', inditex.seoInfo.metaDescription);
                    mainHeader = inditex.seoInfo.mainHeader;
                    if (!mainHeader || mainHeader.indexOf('???') >= 0) {
                        mainHeader = '';
                    }
                    productH1 = inditex.seoInfo.seoProductH1;
                    if (!productH1 || productH1.indexOf('???') >= 0) {
                        productH1 = '';
                    }
                    longDescription = inditex.seoInfo.longDescription;
                    if (!longDescription || longDescriptionindexOf('???') >= 0) {
                        longDescription = '';
                    }
                }

                if (inditex.iPage === 'ItxCategoryPage') {
                    $('.copy-title').html(mainHeader);
                } else {
                    $('.copy-title').html(productH1);
                }

                $('.copy-description').html(longDescription);

                if (inditex.iPage === 'ItxCategoryPage') {
                    setCategoryTitle();
                }
            });
        }

        return {
            _reloadContext: _reloadContext,
            updateMetas: updateMetas
        };
    }
})();